import { has } from "shared/utils";
import { AuditSummaryFlag } from "../AuditSummaryFlag";
import { ApplicantOrInvitee, Verification } from "../../types";
import { EmptyCellIcon } from "./components/EmptyCellIcon";

interface EvictionReportContentProps {
  verification: Verification;
  applicant: ApplicantOrInvitee;
  hasAuditFlagEnabled: boolean;
}

export const EvictionReportContent = ({
  verification,
  applicant,
  hasAuditFlagEnabled
}: EvictionReportContentProps) => {
  if (has(verification.summary?.events_reported))
    return <span>{verification.summary.events_reported}</span>;

  if (hasAuditFlagEnabled && "audit_summary_flags" in applicant)
    return (
      <AuditSummaryFlag audit_summary_flags={applicant.audit_summary_flags} />
    );

  return <EmptyCellIcon />;
};
